import React from 'react';
import { History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';

export function SoiDaoHistory({ items = [] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <History className="h-5 w-5 text-brand-red" />
          ประวัติรอบที่แล้ว
        </CardTitle>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-sm text-gray-500">ยังไม่มีประวัติรอบ</p>
        ) : (
          <ul className="max-h-72 space-y-2 overflow-y-auto">
            {items.map((round) => (
              <li
                key={round.id}
                className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 text-sm"
              >
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold text-brand-red">
                    รอบ #{round.roundNumber}
                  </p>
                  <p className="text-xs text-gray-400">
                    {round.completedAt
                      ? new Date(round.completedAt).toLocaleString('th-TH')
                      : '-'}
                  </p>
                </div>
                <div className="mt-2 grid grid-cols-5 gap-1">
                  {(round.prizes || []).map((prize) => (
                    <div
                      key={`${round.id}-${prize.slot}`}
                      className={`rounded border px-1 py-1 text-center text-[10px] ${
                        prize.status === 'claimed'
                          ? 'border-green-300 bg-green-50'
                          : 'border-gray-200 bg-white'
                      }`}
                    >
                      <p className="font-bold text-brand-gold">
                        {formatMoney(prize.amount)}
                      </p>
                      <p className="font-mono font-semibold text-brand-red">
                        {prize.winningNumber || '--'}
                      </p>
                      {prize.status === 'claimed' ? (
                        <p className="font-mono text-green-800">
                          @{prize.starPosition}
                        </p>
                      ) : (
                        <p className="text-gray-400">
                          {prize.status === 'ready' ? 'พร้อม' : 'สะสม'}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
